import script from "./modernPromo.vue?vue&type=script&lang=ts&setup=true"
export * from "./modernPromo.vue?vue&type=script&lang=ts&setup=true"

import "./modernPromo.vue?vue&type=style&index=0&id=91ae11ee&lang=scss"

const __exports__ = script;

export default __exports__